import Button from 'components/Button';
import Columns2 from 'components/Columns2';
import { Container } from 'flux/utils';
import CurrentUser from 'auth/CurrentUser';
import Select from 'components/Select';
import Fieldset from 'components/Fieldset';
import FormElement from 'components/FormElement';
import * as React from 'react';
import Link from 'components/Link';
// @ts-ignore
import SettingsContainer from './SettingsContainer';
import SettingsStore from 'stores/SettingsStore';
import ToastActions from 'actions/ToastActions';
// @ts-ignore
import UserActions from 'user/UserActions';

interface LanguageElement {
  [key: string]: string
}

type LanguageDict = {
  primary?: LanguageElement,
  secondary: LanguageElement
}

type Props = {
  preferredLanguage?: string
}

type State = {
  canSubmit: boolean,
  languages: LanguageDict,
  chosenLanguage?: string,
};

class UserPreferredLanguageForm extends React.Component<Props, State> {
  static getStores() {
    return [SettingsStore];
  }

  static calculateState() {
    return {
      canSubmit: false,
      languages: SettingsStore.getSetting('languages'),
    };
  }

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  submit = (lang: string) => {
    const reset = () => {
      this.disableButton();
    };

    const onSuccess = () => {
      ToastActions.showSuccessToast('Changes saved');
    };

    const onFailure = (error: any) => {
      ToastActions.showAPIError(error);
      ToastActions.showDefaultErrorToast();
    };

    UserActions.savePreference('preferred_language', lang)
      .then(reset)
      .then(onSuccess, onFailure);
  };

  render() {
    const { preferredLanguage } = this.props || 'none';
    console.log(this.state.languages)
    const language_opts = [{ value: 'none', label: 'No preference' }].concat(
      Object.keys(this.state.languages.secondary).map((lang_code: string) => ({
        value: lang_code,
        label: this.state.languages.secondary[lang_code],
      }))
    );

    return (
      <form
        onSubmit={event => {
          event.preventDefault();
          if (this.state.chosenLanguage) {
            this.submit(this.state.chosenLanguage);
          }
        }}>
        <Fieldset legend="Preferred Language">
          <p>
            Messages you receive will be translated to your preferred language.{' '}
            <Link href="https://help.remind.com/hc/en-us/articles/360018283580">Learn more</Link>
          </p>
          <SettingsContainer>
            <Columns2 gutter="small">
              <div>
                <FormElement
                  label=""
                  ref="preferred_language"
                  onValidChange={value => {
                    if (value === preferredLanguage) {
                      this.disableButton();
                    } else {
                      this.enableButton();
                    }
                    this.setState({ chosenLanguage: value });
                  }}
                  validate={value => {
                    const invalid = value.length < 1;
                    if (invalid) {
                      this.disableButton();
                    }
                  }}
                  element={Select}
                  elementProps={{
                    options: language_opts,
                    value: this.state.chosenLanguage || preferredLanguage,
                  }}
                />
              </div>
            </Columns2>
          </SettingsContainer>
          <Button size="small" type="submit" disabled={!this.state.canSubmit}>
            Save
          </Button>
        </Fieldset>
      </form>
    );
  }
}

export default Container.create<Props, State>(UserPreferredLanguageForm);
